// extracted by mini-css-extract-plugin
module.exports = {"EstimateTitle":"Page_EstimateTitle__8tSBl","Container":"Page_Container__Gmwr9","EstimateAddForm":"Page_EstimateAddForm__AZD6t","EstimateList":"Page_EstimateList__FfKbl"};